import { z } from 'zod'
import { PackageRulesSchema, ShoppingPromotionSchema } from '@reward-platform/shared-schemas'
import { CurrencyCodesSchema } from '@reward-platform/platform-config'
import { AmenitiesGroupSchema } from './amenities'
import { MediaSchema } from './media'
import { PriceLadderSchema } from './price'
import { PricedPaymentOptionSchema } from './payment-option'

const DimensionSchema = z.object({
  sqFeet: z.number().optional(),
  sqMeters: z.number().optional(),
})

export const PromotionConfigSchema = z.object({
  distribution: z.boolean().optional(),
  corporate: z.boolean().optional(),
  packageSalesScenario: z.boolean().optional(),
  mobilePromotion: z.boolean().optional(),
})

export const RoomRateOptionSchema = z.object({
  id: z.string(),
  cashPrice: z.number(),
  cashPriceWithSurcharges: z.number().optional(),
  aviosPrice: z.number(),
  initialLoyaltyAmount: z.number().optional(),
  baseAmount: z.number().optional(),
  collectAmount: z.number(),
  currencyCode: CurrencyCodesSchema,
  available: z.boolean(),
  paymentOptions: z.array(PricedPaymentOptionSchema).optional(),
  pricingLadder: z.array(PriceLadderSchema).optional(),
  optionInfo: z.array(z.string()).optional(),
  packageRules: PackageRulesSchema,
  promotions: z.array(ShoppingPromotionSchema).optional(),
  baseLoyalty: z.number().optional(),
})

export const RoomSchema = z.object({
  name: z.string(),
  roomId: z.string(),
  maxOccupants: z.number().optional(),
  dimensions: DimensionSchema.optional(),
  roomRates: z.array(RoomRateOptionSchema),
  roomAmenities: z.array(AmenitiesGroupSchema),
  beds: z.array(z.object({ title: z.string(), bedGroupId: z.string() })).nonempty(),
  media: z.array(MediaSchema),
})

export const FlexiDetailsRoomSchema = RoomSchema.omit({
  roomRates: true,
})

export type FlexiRoom = z.infer<typeof FlexiDetailsRoomSchema>
export type Room = z.infer<typeof RoomSchema>
export type RoomRateOption = z.infer<typeof RoomRateOptionSchema>
export type PromotionConfig = z.infer<typeof PromotionConfigSchema>
